import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

import { onBeforeMount, ref, watch } from 'vue'
import { useECharts } from '@/hooks/useECharts'
import type { PropType, Ref } from 'vue'
import removeTrailingZeros from '@/utils/format'
import Empty from './Empty.vue'


const __default__ = { name: 'BoardBarChart' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  width: {
    type: String as PropType<string>,
    default: '100%'
  },
  height: {
    type: String as PropType<string>,
    default: '300px'
  },
  data: {
    type: Array as PropType<any[]>,
    default: () => {
      return []
    }
  },
  isPercentageY: {
    type: Boolean as PropType<boolean>,
    default: () => {
      return false
    }
  }
},
  setup(__props) {

const props = __props
const showECharts = ref(false)
const chartRef = ref<HTMLDivElement | null>(null)
const { setOptions } = useECharts(chartRef as Ref<HTMLDivElement>, undefined, false)
watch(
  () => props.data,
  (v) => {
    initChart()
  }
)

const initChart = () => {
  showECharts.value = props.data.length > 0
  setOptions({
    grid: {
      left: '2%',
      right: '2%',
      bottom: '1%',
      // top: '8%',
      containLabel: true
    },
    legend: {
      itemWidth: 12,
      itemHeight: 2,
      left: 'right',
      icon: 'react',
      right: '50%',
      data: props.data.map((item) => item.name)
    },
    tooltip: {
      trigger: 'item',
      backgroundColor: '#1D4CD2',
      textStyle: {
        color: '#fff'
      },
      formatter: function (params) {
        return props.data[params.seriesIndex].value[params.dataIndex].tooltip
      }
    },
    xAxis: {
      type: 'category',
      data: props.data.length > 0 ? props.data[0].value.map((item) => item.name) : []
    },
    yAxis: {
      type: 'value',
      min: 0,
      splitLine: {
        show: true,
        lineStyle: {
          color: '#D8DFE4',
          type: 'dashed'
        }
      }
    },
    series: props.data.map((item) => {
      return { name: item.name, type: 'bar', barMinHeight: 1, data: item.value.map((item) => item.value) }
    })
  })
}

onBeforeMount(() => {
  initChart()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showECharts.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "chartRef",
          ref: chartRef,
          style: _normalizeStyle({ width: __props.width, height: __props.height })
        }, null, 4))
      : _createCommentVNode("", true),
    (!showECharts.value)
      ? (_openBlock(), _createBlock(Empty, {
          key: 1,
          style: _normalizeStyle({ width: __props.width, height: __props.height })
        }, null, 8, ["style"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})